import { render, staticRenderFns } from "./terms_conditions_page.vue?vue&type=template&id=2e973eb5&scoped=true"
import script from "./terms_conditions_page.vue?vue&type=script&lang=js"
export * from "./terms_conditions_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e973eb5",
  null
  
)

export default component.exports